<template>
  <div>
    <h3 class="ui dividing header">
      {{ $t("professor") }}
    </h3>
    <div class="ui fluid search">
      <input
        class="prompt"
        type="text"
        :placeholder="$t('search professor')"
        v-model="professorFilter"
      />
      <div class="results"></div>
    </div>
    <div class="ui vertical secondary menu" ref="tabs">
      <a
        class="item"
        v-for="(professor, pidx) in professors"
        :key="pidx"
        :data-tab="'t_' + professor.uuid"
        @click="select_professor(professor)"
        v-show="
          professorFilter == '' ||
          professor.setup.name
            .toLowerCase()
            .includes(professorFilter.toLowerCase()) ||
          professor.usr_user.name
            .toLowerCase()
            .includes(professorFilter.toLowerCase()) ||
          professor.usr_user.username
            .toLowerCase()
            .includes(professorFilter.toLowerCase())
        "
      >
        {{ professor.setup.name }}</a
      >
    </div>
  </div>
</template>

<script>
import { local_api, error_toast, clone, enterprise_setup } from "@/utils";

export default {
  name: "",
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return { professorFilter: "", professors: [] };
  },
  methods: {
    init() {
      let vm = this;
      local_api(vm, "post", "/professor/professor/do-get-all-list", {})
        .then((professor_list) => {
          let cloned = clone(professor_list);
          vm.professors = cloned;
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    select_professor(professor) {
      this.$emit("select_professor", professor);
    },
  },
  created() {},
  mounted() {
    let vm = this;
    vm.init();
  },
};
</script>
